// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

/**
 * Action button behavior type.
 *
 * Appended to, never reordered: the ordinal IS the wire value, and a row saved
 * by one build is read by another.
 *
 * 0-5 bind TWO commands and press both with `active: true`, differing only in
 * what fires the second — the operator, a countdown, or releasing the button.
 * 6-8 bind ONE command, which is the shape every auto-seeded Control binding
 * actually has, and express "off" as that same command with `active` cleared.
 *
 * ON_OFF and SINGLE existed in `LiftCloud`'s `enums.ActionType` and in the
 * frontend's dispatch before they existed here. Because a Go map miss yields
 * the zero value, `mapActionButtonType` turned both into TOGGLE — silently —
 * and TOGGLE reads a paired command those rows do not have, so the second
 * button rendered enabled and dispatched nothing. Adding them here is what
 * lets the type a row was saved with survive the wire.
 */
export enum ActionButtonType {
  TOGGLE = 0,
  HOLDBACK = 1,
  TURNBACK = 2,
  TOGGLETIMER = 3,
  ENERGIZER_TURN_BACK = 4,
  SWITCH = 5,

  /**
   * One command, two buttons: on presses it with `active: true`, off with
   * `active: false`. The latching shape — a mode or lock that holds until it
   * is cleared (Independent Service, Secure Car Call, the hall-call locks).
   */
  ON_OFF = 6,

  /**
   * One command, one button that alternates its active state. For a control
   * whose current state is already visible elsewhere, where a second button
   * would only restate it.
   */
  SINGLE = 7,

  /**
   * One command, one button: sent once with `active: true`, after which the
   * CONTROLLER owns the state.
   *
   * The shape nothing above can express. Every other self-clearing type here
   * (TURNBACK, SWITCH, ENERGIZER_TURN_BACK) finishes by sending a DIFFERENT
   * command, so a control whose only other edge is the same bit released had
   * no type at all. Registering a hall or car call is exactly that: the
   * master asserts the request, the controller latches it, and the call ends
   * when the car arrives — a moment the UI cannot know and must not predict.
   *
   * A release is OPT-IN through the row's `timer`, because whether one is
   * wanted is a property of the controller: an edge-triggered one expects
   * the master to let go, while a level-triggered one treats the asserted
   * bit AS the request, so releasing it cancels the call just placed. The
   * default does not release, because holding a bit nobody needs is
   * invisible while dropping a live call is a reported fault.
   */
  ONE_SHOT = 8,
}
